var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-container" },
    [
      _c(
        "div",
        { staticClass: "search-left" },
        [
          _c("DynamicOption", {
            attrs: { singleSelect: true },
            model: {
              value: _vm.searchParams.channelId,
              callback: function ($$v) {
                _vm.$set(_vm.searchParams, "channelId", $$v)
              },
              expression: "searchParams.channelId",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search-right" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "SECURITY_CHANNEL_CONFIG_SEARCH",
                  expression: "'SECURITY_CHANNEL_CONFIG_SEARCH'",
                },
              ],
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.search },
            },
            [_vm._v("搜索")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "SECURITY_CHANNEL_CONFIG_ADD",
                  expression: "'SECURITY_CHANNEL_CONFIG_ADD'",
                },
              ],
              attrs: { size: "small" },
              on: { click: _vm.add },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c("Add", { ref: "add" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }